var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00016 8.66683C10.4729 8.66683 11.6668 7.47292 11.6668 6.00016C11.6668 4.5274 10.4729 3.3335 9.00016 3.3335C7.5274 3.3335 6.3335 4.5274 6.3335 6.00016C6.3335 7.47292 7.5274 8.66683 9.00016 8.66683ZM4.66683 10.6668C5.5873 10.6668 6.3335 9.92063 6.3335 9.00016C6.3335 8.07969 5.5873 7.3335 4.66683 7.3335C3.74636 7.3335 3.00016 8.07969 3.00016 9.00016C3.00016 9.92063 3.74636 10.6668 4.66683 10.6668ZM15.0002 9.00016C15.0002 9.92063 14.254 10.6668 13.3335 10.6668C12.413 10.6668 11.6668 9.92063 11.6668 9.00016C11.6668 8.07969 12.413 7.3335 13.3335 7.3335C14.254 7.3335 15.0002 8.07969 15.0002 9.00016ZM9.00016 9.3335C10.8411 9.3335 12.3335 10.8259 12.3335 12.6668V16.6668H5.66683V12.6668C5.66683 10.8259 7.15922 9.3335 9.00016 9.3335ZM4.3335 12.6668C4.3335 12.2048 4.40061 11.7586 4.52562 11.3372L4.41259 11.3471C3.24352 11.4738 2.3335 12.464 2.3335 13.6668V16.6668H4.3335V12.6668ZM15.6668 16.6668V13.6668C15.6668 12.4254 14.6974 11.4104 13.4747 11.3372C13.5997 11.7586 13.6668 12.2048 13.6668 12.6668V16.6668H15.6668Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeam);
export default __webpack_public_path__ + "static/media/iconTeam.470055a1.svg";
export { ForwardRef as ReactComponent };